/** @format */

export function UiConfig(
    $mdThemingProvider,
    $ccToastProvider,
    $mdColorPalette,
    $ccProgressiveLoadingProvider,
    $ccImageLoaderProvider,
    $gbThemingProvider
) {
    'ngInject';

    $mdThemingProvider.definePalette('success', $mdColorPalette.green);

    // const GB_PRIMARY_COLOR = '#44b077'; // logo color
    const GB_BACKGROUND_COLOR = '#fafafa'; // off-white
    const GB_PRIMARY_COLOR = '#39a080'; // darker shade of logo color
    const GB_ACCENT_COLOR = GB_PRIMARY_COLOR;
    const GB_SUCCESS_COLOR = GB_PRIMARY_COLOR;
    const GB_WARN_COLOR = '#f44336'; // default material red palette color
    const GB_CAUTION_COLOR = '#ffc107'; // default material amber palette color

    $gbThemingProvider.defineTheme('default', {
        background: GB_BACKGROUND_COLOR,
        primary: GB_PRIMARY_COLOR,
        accent: GB_ACCENT_COLOR,
        warn: GB_WARN_COLOR,
        success: GB_SUCCESS_COLOR,
        caution: GB_CAUTION_COLOR,
    });

    $ccToastProvider.successColor($mdColorPalette.green['600']).errorParser('gbToastErrorParser');

    // Progressive image loading
    $ccProgressiveLoadingProvider.enableProgressiveLoading(true);

    $ccProgressiveLoadingProvider
        .profile('c_preload', {
            width: 64,
            height: 64,
        })
        .profile('c_thumbnail', {
            width: 128,
            height: 128,
        })
        .profile('c_small', {
            width: 256,
            height: 256,
        })
        .profile('c_medium', {
            width: 512,
            height: 512,
        })
        .profile('image');

    $ccImageLoaderProvider.setImageInterceptor(($gbAuctionImage, $ccProgressiveLoading) => {
        'ngInject';

        return (id, profile) => {
            let image = $gbAuctionImage.cache.single(id);

            if (!image) {
                return;
            }

            if (!profile || !image[profile]) {
                return image.image;
            }

            return image[profile];
        };
    });
}
